const getters = {
  getWrldUserLang: (state) => (state.lang)
}
export default getters
